import React, { useEffect, useState } from "react";
import { useScannerContext } from "../scanners/ScannerContext";
import { BarcodeDataType, ReadyToSendDto, ReadyToSendApiResponse } from "../scanners/types";
import { apiHost, apiKey, showManualQrCodeInput } from "@/constants";
import { barcodeDataTypeFromQrCode, hasQRcodeNumberPattern } from "../scanners/helpers";
import QrCodeInputField from "../scanners/QrCodeInputField";
import { RowData } from "./types";
import { primaryButtonClasses } from "@/helpers/style.helpers";
import { Card } from "./Card";

type ScanProps = {
  data: RowData;
  onClose: () => void;
};

export const Scan: React.FC<ScanProps> = ({ data, onClose }) => {
  const { scannedData, setScannedData, enableScanner, clearScannedData } = useScannerContext();

  const [bagDataString, setBagDataString] = useState<string | null>(null);
  const [apiResponse, setApiResponse] = useState<ReadyToSendApiResponse | null>(null);

  useEffect(() => {
    return () => {
      clearScannedData();
    };
  }, [clearScannedData]);

  useEffect(() => {
    if (scannedData) {
      if (hasQRcodeNumberPattern(scannedData)) {
        // Get the entity the barcode belongs to (product, bag, bin)
        const dataLabelType = barcodeDataTypeFromQrCode(scannedData);
        // Bag scan
        if (dataLabelType === BarcodeDataType.ORDER_BAG) {
          setBagDataString(scannedData);
          // Product scan
        } else {
          setApiResponse({
            message: "INVALID_BARCODE_DATA",
          });
        }
      } else {
        setApiResponse({
          message: "INVALID_BARCODE_DATA",
        });
      }
    }
  }, [scannedData]);

  useEffect(() => {
    if (bagDataString && data) {
      fetchApiData(bagDataString, data);
    }
  }, [bagDataString, data]);

  const fetchApiData = async (bagDataString: string | null, rowData: RowData) => {
    if (bagDataString === null) {
      return;
    }
    try {
      const data: ReadyToSendDto = {
        dataString: bagDataString,
        binId: rowData.bin.id,
        orderId: rowData?.order?.id || "",
      };

      const response = await fetch(`${apiHost}/orders/by-datastring/ready-to-send`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": apiKey,
        },
        body: JSON.stringify(data),
      });
      const responseData: ReadyToSendApiResponse = await response.json();
      setApiResponse(responseData);
    } catch (err) {
      setApiResponse({
        message: (err as Error).message,
      });
    }
  };

  useEffect(() => {
    void enableScanner(true);
  }, [enableScanner]);

  return (
    <div className="fixed inset-0 bg-gray-100 flex flex-col justify-center items-center p-4">
      <Card data={apiResponse} bin={data.bin} />
      <button className={primaryButtonClasses} onClick={onClose}>
        Sluiten
      </button>
      {showManualQrCodeInput && (
        <QrCodeInputField
          onChange={(value: string) => {
            setScannedData(value);
          }}
        />
      )}
    </div>
  );
};
